<div class="solid-fallback-background"></div>
<div class="prelogin-background"></div>
<div class="container">
  <div class="prelogin-logo-container" (click)="home()">
    <img class="prelogin-logo" src="../../../../assets/hubtiger_logo_full.png">
  </div>
  <div class="prelogin-container">
    <div class="row">
      <div class="col-md-12 subcontainer">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <div class="signup-box">
    <div class="signup-title">Don't have an account yet?</div>
    <div class="signup-container">
      <div (click)="bikeshopWizard()">Create Account</div>
      <!--<div (click)="clubsWizard()">Cycling club signup</div>-->
    </div>
  </div>
</div>
<!--  <app-help-request></app-help-request>-->
